import { Injectable } from '@angular/core';
import { ServiceBase, OrigamiResponse } from './base/service.base';
import { Observable } from 'rxjs';

export interface CreateFAQ {
  faq: {
    SiteId: number;
    TopicId?: number;
    TopicFields: {
      FieldName: string;
      Fieldvalue: string | number;
      FieldType: number;
    }[];
  };
}

export interface DeleteFAQ {
  siteId: number;
  topicIds: number[];
}

export interface DeleteQA {
  deletionReason: string;
  isPermanentDeletion: boolean;
  qaIds: number[];
  siteId: number;
}

export interface CreateQuestion {
  questionCustomFields: string[];
  questionParentIds: number[];
  questionLevel: number;
  questionSubjectMatterId: number;
  questionTargetIds: number[];
  questionTitle: string;
  siteId: number;
}

export interface CreateAnswer {
  answerCustomFields: string[];
  answerParentIds: number[];
  answerTitle: string;
  siteId: number;
}

export interface GetFaqViewsParams {
  siteId: number;
  viewMode: number;
}

export interface FaqView {
  EntitiesCount: number;
  ViewFilterDisplayName: string;
  ViewFilterId: string;
  ViewMode: number;
}

@Injectable()
export class QAService extends ServiceBase {
  serviceUrl = 'QAService.svc';

  getQATree(body, ...params) {
    return this.origamiPost('/GetQATree', body, ...params);
  }

  getQAByView(body, ...params) {
    return this.origamiPost('/GetQAByView', body, ...params);
  }

  getFAQViews(params: GetFaqViewsParams, ...options): Observable<OrigamiResponse<FaqView[]>> {
    return this.origamiPost('/GetFAQViews', params, ...options);
  }

  getFAQRecords(body, ...params) {
    return this.origamiPost('/GetFAQRecords', body, ...params);
  }

  createFAQ(body: CreateFAQ) {
    return this.origamiPost('/CreateFAQ', body, null, null, true);
  }

  deleteFAQ(body: DeleteFAQ) {
    return this.origamiPost('/DeleteFAQ', body, null, null, true);
  }

  deleteQA(body: DeleteQA) {
    return this.origamiPost('/DeleteQATree', body, null, null, true);
  }

  modifyFAQ(body: CreateFAQ) {
    return this.origamiPost('/ModifyFAQ', body, null, null, true);
  }

  exportFAQ(body) {
    return this.origamiPost('/ExportFAQ', body, null, null, true);
  }

  createQuestion(body: CreateQuestion) {
    return this.origamiPost('/CreateQuestion', body, null, null, true);
  }

  createAnswer(body: CreateAnswer) {
    return this.origamiPost('/CreateAnswer', body, null, null, true);
  }

  exportQA(body) {
    return this.origamiPost('/ExportQA', body, null, null, true);
  }
}
